module.exports = __webpack_public_path__ + "img/icon-fullscreen.2639732f.svg";